// ChatBubble — Floating chat button (matches the base44 design)
// Light blue/purple circular button with a chat icon. Opens support chat
// on click (placeholder: navigates to /portal/help).

import { useNavigate } from 'react-router-dom';

export function ChatBubble({ className = '' }: { className?: string }) {
  const nav = useNavigate();
  return (
    <button
      onClick={() => nav('/portal/help')}
      aria-label="Open chat"
      data-testid="chat-bubble"
      className={['flex h-12 w-12 items-center justify-center rounded-full bg-[#7E9AFF] text-white shadow-[0_8px_24px_rgba(126,154,255,0.5)] active:scale-95 transition', className].join(' ')}
    >
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden>
        <path d="M3 3h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2z" />
      </svg>
    </button>
  );
}
